import { $Q, $Qll } from '../utils/query-selector';
import Swiper, {
  Navigation,
  Pagination,
  FreeMode,
  Autoplay,
  Thumbs,
} from 'swiper';

export const sliderSuggestProducts = () => {
  // eslint-disable-next-line no-new
  new Swiper('.products-suggest-slider', {
    modules: [Navigation, FreeMode],
    slidesPerView: 'auto',
    spaceBetween: 15,
    navigation: {
      nextEl: `.swiper-button-next[data-slider="products-suggest-slider"]`,
      prevEl: `.swiper-button-prev[data-slider="products-suggest-slider"]`,
    },
    freeMode: true,
    breakpoints: {
      749: {
        slidesPerView: 4,
      },
    },
  });
};

/**
 * Create new slider with arrows
 * @param {String} id - className reference in DOM
 */
const configArrows = (id) => {
  // eslint-disable-next-line no-new
  new Swiper(id, {
    modules: [Navigation, FreeMode],
    slidesPerView: 'auto',
    spaceBetween: 25,
    navigation: {
      nextEl: `.swiper-button-next`,
      prevEl: `.swiper-button-prev`,
    },
    freeMode: true,
    breakpoints: {
      749: {
        slidesPerView: 3,
        spaceBetween: 28,
        freeMode: false,
      },
    },
  });
};

/**
 * Create new slider with pagination
 * @param {String} id - className reference in DOM
 */
export const configPagination = (id) => {
  // eslint-disable-next-line no-new
  new Swiper(id, {
    modules: [Pagination, FreeMode],
    slidesPerView: 'auto',
    spaceBetween: 25,
    pagination: {
      el: `.swiper-pagination[data-id="${id.substr(1)}"]`,
    },
    freeMode: true,
    breakpoints: {
      749: {
        slidesPerView: 3,
        spaceBetween: 28,
        freeMode: false,
      },
    },
  });
};

const configSwiperUpsell = {
  modules: [Navigation, FreeMode],
  slidesPerView: 3,
  spaceBetween: 32,
  navigation: {
    nextEl: `.swiper-button-next[data-slider="upsell"]`,
    prevEl: `.swiper-button-prev[data-slider="upsell"]`,
  },
  freeMode: false,
};

const configSwiperReassurance = {
  modules: [Pagination, FreeMode, Autoplay],
  slidesPerView: 1,
  freeMode: false,
  autoplay: {
    delay: 8000,
    disableOnInteraction: false,
  },
  pagination: {
    el: `.swiper-pagination[data-slider="ressurance"]`,
    clickable: true,
  },
};

export const configSwiperUpsellMetaVertical = {
  modules: [Navigation, FreeMode],
  direction: 'vertical',
  spaceBetween: 25,
  slidesPerView: 3,
  freeMode: true,
  loop: true,
  navigation: {
    nextEl: `.swiper-vertical-button-next[data-slider="upsell"]`,
    prevEl: `.swiper-vertical-button-prev[data-slider="upsell"]`,
  },
};

export const configSwiperUpsellMeta = {
  modules: [Pagination, Navigation, FreeMode],
  slidesPerView: 1,
  spaceBetween: 28,
  loop: true,
  navigation: {
    nextEl: `.swiper-button-next[data-slider="upsell"]`,
    prevEl: `.swiper-button-prev[data-slider="upsell"]`,
  },
  pagination: {
    el: `.swiper-pagination[data-slider="upsell"]`,
    clickable: true,
  },
  freeMode: true,
  breakpoints: {
    767: {
      slidesPerView: 1,
      spaceBetween: 32,
      freeMode: false,
      loop: true,
    },
  },
};

/**
 * Create new slider - 1 slide per view
 * @param {String} id - className reference in DOM
 */
export const swiperSmall = new Swiper('.slider_small', {
  modules: [Pagination, Autoplay, FreeMode],
  slidesPerView: 1,
  spaceBetween: 25,
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
  },
  freeMode: true,
  autoplay: {
    delay: 3000,
    disableOnInteraction: false,
  },
});

/**
 * Iteration to create all sliders with arrows
 */
export const swiperArrows = (() => {
  $Qll('.slider_arrows').map((slide) => configArrows(`#${slide.id}`));
})();

/**
 * Iteration to create all sliders with pagination
 */
export const swiperPagination = (() => {
  $Qll('.slider_pagination').map((slide) => configPagination(`#${slide.id}`));
})();

export const sliderUpsell = () => {
  // eslint-disable-next-line no-new
  new Swiper('.slider_upsell', configSwiperUpsell);
};

export const sliderReassurance = () => {
  // eslint-disable-next-line no-new
  new Swiper('.slider_ressurance', configSwiperReassurance);
};

export const sliderUpsellMeta = () => {
  // eslint-disable-next-line no-new
  new Swiper('.slider_upsell', configSwiperUpsellMeta);
};

export const sliderUpsellVertical = () => {
  // eslint-disable-next-line no-new
  new Swiper('.vertical-slider', configSwiperUpsellMetaVertical);
};

export const validateUpsellPosition = () => {
  if ($Q('#side-cart').dataset.upsellDirection === 'true') {
    sliderUpsellVertical();
    return;
  }

  sliderUpsellMeta();
};

export const sliderGallery = () => {
  const thumb = new Swiper('.gallery-slider-thumb', {
    modules: [FreeMode],
    spaceBetween: 13,
    slidesPerView: 'auto',
    freeMode: true,
    watchSlidesProgress: true,
  });

  // eslint-disable-next-line no-new
  new Swiper('.gallery-slider', {
    modules: [Thumbs],
    slidesPerView: 1,
    thumbs: {
      swiper: thumb,
    },
  });
};

export const sliderProductReasurance = () => {
  const configProductPage = {
    modules: [Pagination, FreeMode, Autoplay],
    slidesPerView: 1,
    freeMode: false,
    pagination: {
      el: `.swiper-pagination[data-slider="slider_ressurance_product"]`,
      clickable: true,
    },
    breakpoints: {
      767: {
        slidesPerView: 3,
        spaceBetween: 40,
        freeMode: false,
        preventInteractionOnTransition: false,
        pagination: {},
      },
    },
  };
  // eslint-disable-next-line no-new
  new Swiper('.slider_ressurance_product', configProductPage);
};

export const sliderCustomerService = () => {
  const configCustomerService = {
    modules: [Pagination, FreeMode, Autoplay],
    slidesPerView: 1,
    freeMode: false,
    pagination: {
      el: `.swiper-pagination[data-slider="slider_customer_service"]`,
      clickable: true,
    },
  };

  // eslint-disable-next-line no-new
  new Swiper('.slider_customer_service', configCustomerService);
};

export const sliderSimplePress = () => {
  const configPress = {
    modules: [Pagination, FreeMode],
    slidesPerView: 3,
    freeMode: false,
    pagination: {
      el: `.swiper-pagination[data-slider="slider_press_product"]`,
      clickable: true,
    },
    breakpoints: {
      749: {
        slidesPerView: 7,
        spaceBetween: 50,
      },
    },
  };
  // eslint-disable-next-line no-new
  new Swiper('.slider_press_product', configPress);
};

export const slidersMobile = () => {
  if (window.innerWidth <= 768) {
    const configGeneralInfo = {
      modules: [Pagination, FreeMode, Autoplay],
      slidesPerView: 1,
      freeMode: false,
      pagination: {
        el: `.swiper-pagination[data-slider="slider_general_info"]`,
        clickable: true,
      },
    };

    // eslint-disable-next-line no-new
    new Swiper('.slider_general_info', configGeneralInfo);
  }
};

export const sliderBanner = () => {
  const documentBody = document.querySelector('body');
  // eslint-disable-next-line no-new
  new Swiper('.banner-slider', {
    modules: [Pagination, FreeMode, Autoplay],
    slidesPerView: 'auto',
    loop: false,
    pagination: {
      el: `.swiper-pagination[data-slider="banner-slider"]`,
      clickable: true,
    },
    autoplay: {
      delay: 8000,
      disableOnInteraction: false,
    },
    breakpoints: {
      749: {
        direction: 'vertical',
        mousewheel: true,
        sensitivity: 0.1,
        keyboard: true,
        releaseOnEdges: true,
        on: {
          reachEnd: function () {
            documentBody.setAttribute('style', 'overflow: auto;');
          },
        },
      },
    },
  });
};
